module.exports = __webpack_public_path__ + "static/media/282532_Information_R_blue.af795a84.png";